import { Link } from "react-router-dom";
import { CalendarDays, ChevronRight, Heart, MapPin } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { PrayerTimesRow } from "@/components/PrayerTimes";

export const MyMosqueCard = ({ mosque }) => {
  const { t, lang } = useLang();
  const locale = lang === "fr" ? "fr-FR" : "en-US";
  const base = `/${mosque.association_slug}`;
  const ev = mosque.next_event;
  const evDate = ev ? new Date(ev.start) : null;

  return (
    <div data-testid="my-mosque-card" className="border border-border rounded-xl bg-card overflow-hidden mb-4 fade-up">
      <Link to={`${base}/mosques/${mosque.id}`} data-testid="my-mosque-link" className="block relative group">
        {mosque.photo ? (
          <img src={mosque.photo} alt={mosque.name} className="w-full h-28 object-cover transition-transform duration-500 group-hover:scale-[1.02]" />
        ) : (
          <div className="w-full h-28" style={{ background: mosque.color }} />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[10px] font-mono-data uppercase tracking-widest text-white/80 flex items-center gap-1.5 mb-0.5">
              <Heart className="h-3 w-3 fill-red-400 text-red-400" /> {t("my_mosque")}
            </p>
            <h2 className="font-heading font-bold text-white text-lg leading-tight truncate">{mosque.name}</h2>
            {mosque.address && (
              <p className="text-[11px] text-white/70 truncate flex items-center gap-1 mt-0.5">
                <MapPin className="h-3 w-3 shrink-0" />{mosque.address}
              </p>
            )}
          </div>
          <ChevronRight className="h-5 w-5 text-white/80 shrink-0 transition-transform group-hover:translate-x-0.5" />
        </div>
      </Link>
      <PrayerTimesRow slug={mosque.association_slug} mosqueId={mosque.id} />
      <div className="flex items-stretch divide-x divide-border border-t border-border">
        {ev ? (
          <Link to={`${base}/events/${ev.id}`} data-testid="my-mosque-next-event" className="flex-1 min-w-0 px-4 py-2.5 hover:bg-muted transition-colors">
            <p className="text-[10px] font-mono-data uppercase tracking-wider text-muted-foreground">{t("next_event")}</p>
            <p className="text-sm font-medium truncate">
              {ev.title}
              <span className="text-muted-foreground font-mono-data text-xs"> · {evDate.toLocaleDateString(locale, { day: "numeric", month: "short" })} {evDate.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })}</span>
            </p>
          </Link>
        ) : (
          <div className="flex-1 min-w-0 px-4 py-2.5">
            <p className="text-[10px] font-mono-data uppercase tracking-wider text-muted-foreground">{t("next_event")}</p>
            <p className="text-sm text-muted-foreground">{t("no_upcoming_event")}</p>
          </div>
        )}
        <Link to={`${base}/calendar`} data-testid="my-mosque-calendar-btn" className="px-4 flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground hover:bg-muted transition-colors shrink-0">
          <CalendarDays className="h-4 w-4" /> <span className="hidden sm:inline">{t("calendar")}</span>
        </Link>
      </div>
    </div>
  );
};
